// global shared items
require('./shared')

require('../site_scripts/mtc_vue_import')

require('./shared_functions')

// compared cars specific JS
require('../../../../core/js/plugins/mtc_match_height');
require('../site_scripts/mtc_storefront_popup')
require('../site_scripts/mtc_compared_cars');

// compared cars specific styles
require('../../css/compared_cars.less')
